module.exports = __webpack_public_path__ + "media/images/banners/session-tech2025-5fbee22f6e4ec0130d44df9c07ac2a16.png";